var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinEarth = function SvgPinEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 12,
    cy: 9.75,
    r: 6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.8 6.751h1.45a1.5 1.5 0 0 1 1.5 1.5v.7a1.5 1.5 0 0 0 .668 1.248l.958.639a1.4 1.4 0 0 1 0 2.332l-2.531 1.684M17.2 6.751h-.7a1.5 1.5 0 0 0-1.342 2.171c.427.854.525.895.79 1.054l1.9 1.138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 9.75c0 7.9-6.932 12.331-8.629 13.3a.75.75 0 0 1-.743 0C9.931 22.08 3 17.648 3 9.75a9 9 0 0 1 18 0"
  })));
};
export default SvgPinEarth;